
import LogosCarousel from '~/components/LogosCarousel.vue'
export default {
  name: 'CompaniesSlice',
  components: { LogosCarousel },
  props: ['slice'],
  data() {
    return {
      pretitle: {
        en: `Companies that have chosen Vitesy`,
        it: `Le aziende che hanno scelto Vitesy`,
        de: `Unternehmen, die sich für Vitesy entschieden haben`
      },
      logos: {
        companies: [
          {
            url: '/img/logos/company-smeg.svg',
            dimensions: { width: 180, height: 80 }
          },
          {
            url: '/img/logos/company-bosch.svg',
            dimensions: { width: 180, height: 80 }
          },
          {
            url: '/img/logos/company-ovs.svg',
            dimensions: { width: 200, height: 100 }
          },
          {
            url: '/img/logos/company-coin.svg',
            dimensions: { width: 200, height: 100 }
          },
          {
            url: '/img/logos/company-henkel.svg',
            dimensions: { width: 200, height: 100 }
          },
          {
            url: '/img/logos/company-iren.svg',
            dimensions: { width: 200, height: 100 }
          },
          {
            url: '/img/logos/company-tag.svg',
            dimensions: { width: 200, height: 100 }
          },
          {
            url: '/img/logos/company-birdie.svg',
            dimensions: { width: 200, height: 100 }
          },
        ],
        partners: [
          {
            url: '/img/logos/company-indigo.svg',
            dimensions: { width: 160, height: 80 }
          },
          {
            url: '/img/logos/company-webidoo.svg',
            dimensions: { width: 160, height: 80 }
          },
          {
            url: '/img/logos/company-coin.svg',
            dimensions: { width: 160, height: 80 }
          },
          // {
          //   url: '/img/logos/company-intelligent-appliances.svg',
          //   dimensions: { width: 160, height: 80 }
          // },
          {
            url: '/img/logos/company-ssense.svg',
            dimensions: { width: 160, height: 80 }
          }
        ]
      }
    }
  },
  computed: {
    items(){
      return this.logos[this.slice.primary.type || 'companies']
    }
  }
}
